var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClassroom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63672 2.13672H16.364V14.4094H1.63672V2.13672Z",
    fill: "#0F9D58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2738 8.6827C12.7817 8.6827 13.1942 8.2702 13.1942 7.76225C13.1942 7.2543 12.7817 6.8418 12.2738 6.8418C11.7658 6.8418 11.3533 7.2543 11.3533 7.76225C11.3533 8.2702 11.7658 8.6827 12.2738 8.6827ZM12.2738 9.29634C11.2885 9.29634 10.2283 9.81793 10.2283 10.4657V11.1372H14.3192V10.4657C14.3192 9.81793 13.259 9.29634 12.2738 9.29634ZM5.72832 8.6827C6.23627 8.6827 6.64877 8.2702 6.64877 7.76225C6.64877 7.2543 6.23627 6.8418 5.72832 6.8418C5.22036 6.8418 4.80786 7.2543 4.80786 7.76225C4.80786 8.2702 5.22036 8.6827 5.72832 8.6827ZM5.72832 9.29634C4.74309 9.29634 3.68286 9.81793 3.68286 10.4657V11.1372H7.77377V10.4657C7.77377 9.81793 6.71354 9.29634 5.72832 9.29634Z",
    fill: "#57BB8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99962 7.86275C9.67803 7.86275 10.2269 7.31388 10.2269 6.63547C10.2269 5.95707 9.67803 5.4082 8.99962 5.4082C8.32121 5.4082 7.77235 5.95707 7.77235 6.63547C7.77235 7.31388 8.32121 7.86275 8.99962 7.86275ZM8.99962 8.68093C7.61894 8.68093 6.13599 9.41388 6.13599 10.3173V11.1355H11.8633V10.3173C11.8633 9.41388 10.3803 8.68093 8.99962 8.68093Z",
    fill: "#F7F7F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.636 13.5918H14.3178V14.41H10.636V13.5918Z",
    fill: "#F1F1F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7727 0.5H1.22727C0.548864 0.5 0 1.04886 0 1.72727V14.8182C0 15.4966 0.548864 16.0455 1.22727 16.0455H16.7727C17.4511 16.0455 18 15.4966 18 14.8182V1.72727C18 1.04886 17.4511 0.5 16.7727 0.5ZM16.3636 14.4091H1.63636V2.13636H16.3636V14.4091Z",
    fill: "#F4B400"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.7727 0.5H1.22727C0.548864 0.5 0 1.04886 0 1.72727V1.82955C0 1.15114 0.548864 0.602273 1.22727 0.602273H16.7727C17.4511 0.602273 18 1.15114 18 1.82955V1.72727C18 1.04886 17.4511 0.5 16.7727 0.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.7727 15.9441H1.22727C0.548864 15.9441 0 15.3952 0 14.7168V14.8191C0 15.4975 0.548864 16.0463 1.22727 16.0463H16.7727C17.4511 16.0463 18 15.4975 18 14.8191V14.7168C18 15.3952 17.4511 15.9441 16.7727 15.9441Z",
    fill: "#BF360C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3112 14.4082H10.6294L12.2658 16.0446H15.9442L14.3112 14.4082Z",
    fill: "url(#paint0_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1.63672 2.0332H16.364V2.13547H1.63672V2.0332Z",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1.63672 14.4082H16.364V14.5105H1.63672V14.4082Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7727 0.5H1.22727C0.548864 0.5 0 1.04886 0 1.72727V14.8182C0 15.4966 0.548864 16.0455 1.22727 16.0455H16.7727C17.4511 16.0455 18 15.4966 18 14.8182V1.72727C18 1.04886 17.4511 0.5 16.7727 0.5Z",
    fill: "url(#paint1_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 13.2869,
    y1: 14.4309,
    x2: 13.2869,
    y2: 16.0616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF360C",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF360C",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.529808 0.864384) scale(74.2681 74.2678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassroom);
export default __webpack_public_path__ + "static/media/classroom.e00413c0.svg";
export { ForwardRef as ReactComponent };